const webSocketUrl = process.env.REACT_APP_OE_SERVER || ''

export default webSocketUrl
